import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import FormView from '../FormView';

const Preview = ({ formData }) => {

  return (
    <FormView formData={formData} />
  );
};

export default Preview;